// ============================================================
// Blog posts (S14 / C13). Shared by the /blog index, the route list
// in src/siteRoutes.js and each post page. Copy is written from the
// facts in the 16 Oct 2026 content pack; swap in the SEO writer's
// version when the separate blog file arrives (URLs stay the same).
// `published` / `updated` (YYYY-MM-DD) feed the on-page dates, the
// BlogPosting schema and the sitemap <lastmod>: set `updated` whenever
// a post's copy changes. `label` is also the headline on the post's
// share image, which scripts/prerender.js draws at build time.
// Posts 7 and 8 come from the SEO writer's blog file (22 Oct 2026);
// `category` and `keyword` feed the BlogPosting articleSection/keywords.
// Post 9 comes from the spring cleaning blog file (28 Oct 2026).
// Post 10 comes from the prepare for a house cleaner file (31 Oct 2026).
// Post 11 comes from the how often to clean file (2 Nov 2026). Posts 8-11
// all went live in the 2 Nov 2026 deploy, so their dates are 2026-11-02.
// ============================================================

import { blogPaths } from './paths';

export const blogPosts = [
  {
    path: blogPaths.houseCleaningCost,
    file: 'src/pages/blog/HouseCleaningCostPost.js',
    published: '2026-10-19',
    updated: '2026-11-02',
    label: 'House Cleaning Cost Guide',
    title: 'How Much Does House Cleaning Cost in Auckland? (2026 Price Guide)',
    excerpt: 'Real 2026 prices by property size for standard and deep cleans, what changes the price, and how to get a fixed quote.',
  },
  {
    path: blogPaths.endOfTenancyChecklist,
    file: 'src/pages/blog/EndOfTenancyChecklistPost.js',
    published: '2026-10-19',
    label: 'End of Tenancy Checklist',
    title: 'End of Tenancy Cleaning Checklist NZ: Room by Room',
    excerpt: 'A room-by-room move-out checklist for NZ renters, the areas property managers check first, and how to prepare for the final inspection.',
  },
  {
    path: blogPaths.deepVsRegular,
    file: 'src/pages/blog/DeepVsRegularPost.js',
    published: '2026-10-19',
    updated: '2026-11-02',
    label: 'Deep Clean vs Regular Clean',
    title: 'Deep Clean vs Regular Clean: Which One Does Your Home Need?',
    excerpt: 'What each clean covers, what a deep clean adds, how the prices compare and when to book each one.',
  },
  {
    path: blogPaths.commercialCost,
    file: 'src/pages/blog/CommercialCleaningCostPost.js',
    published: '2026-10-19',
    label: 'Commercial Cleaning Cost',
    title: 'Commercial Cleaning Cost in Auckland: What Affects the Price',
    excerpt: 'Why commercial cleaning is quoted per site, the common pricing models, and what a good written quote should include.',
  },
  {
    path: blogPaths.officeFrequency,
    file: 'src/pages/blog/OfficeCleaningFrequencyPost.js',
    published: '2026-10-19',
    label: 'How Often to Clean an Office',
    title: 'How Often Should an Office Be Cleaned?',
    excerpt: 'Daily, weekly and periodic office cleaning tasks, example schedules by office type, and signs your schedule needs to change.',
  },
  {
    path: blogPaths.moveInChecklist,
    file: 'src/pages/blog/MoveInChecklistPost.js',
    published: '2026-10-19',
    updated: '2026-11-02',
    label: 'Move-In Cleaning Checklist',
    title: 'Move-In Cleaning Checklist NZ: Clean Before You Unpack',
    excerpt: 'What to clean and check in a new home or rental before the furniture arrives, room by room.',
  },
  {
    path: blogPaths.twoBedroomCost,
    file: 'src/pages/blog/TwoBedroomCleanCostPost.js',
    published: '2026-10-27',
    label: '2 Bedroom Clean Cost',
    category: 'Pricing guides',
    keyword: '2 bedroom house cleaning cost Auckland',
    title: 'How Much Does a 2 Bedroom Clean Cost in Auckland? (2026 Prices)',
    excerpt: '2026 prices for standard and deep cleans of a 2 bedroom home, add-on costs, the yearly cost of a regular plan and how to save.',
  },
  {
    path: blogPaths.airbnbChecklist,
    file: 'src/pages/blog/AirbnbCleaningChecklistPost.js',
    published: '2026-11-02',
    label: 'Airbnb Cleaning Checklist',
    category: 'Checklists',
    keyword: 'Airbnb cleaning checklist NZ',
    title: 'Airbnb and Short-Stay Cleaning Checklist for NZ Hosts',
    excerpt: 'A room-by-room turnover checklist for short-stay hosts: what to clean, restock and photograph between guests.',
  },
  {
    path: blogPaths.springChecklist,
    file: 'src/pages/blog/SpringCleaningChecklistPost.js',
    published: '2026-11-02',
    label: 'Spring Cleaning Checklist',
    category: 'Checklists',
    keyword: 'spring cleaning checklist NZ',
    title: 'Spring Cleaning Checklist for NZ Homes (Room by Room)',
    excerpt: 'A room-by-room spring cleaning checklist for NZ homes: what to declutter, deep clean and reset this season, plus when to call a cleaner.',
  },
  {
    path: blogPaths.prepareForCleaner,
    file: 'src/pages/blog/PrepareForCleanerPost.js',
    published: '2026-11-02',
    label: 'Prepare for a House Cleaner',
    category: 'Guides',
    keyword: 'how to prepare for a house cleaner',
    title: 'How to Prepare Your Home for a House Cleaner (12-Step Checklist)',
    excerpt: 'What to tidy, put away and tell your cleaner before a professional clean, plus how a PureNest clean works from booking to finish.',
  },
  {
    path: blogPaths.howOftenToClean,
    file: 'src/pages/blog/HowOftenToCleanPost.js',
    published: '2026-11-02',
    label: 'How Often to Clean Your House',
    category: 'Guides',
    keyword: 'how often should you clean your house',
    title: 'How Often Should You Clean Your House? (A Room-by-Room Schedule)',
    excerpt: 'A simple cleaning schedule for NZ homes: what to clean daily, weekly, monthly and once or twice a year, and which plan suits your household.',
  },
];

export const getBlogPost = (path) => blogPosts.find((post) => post.path === path);

// Share image per post: /blog/<slug> uses /og-blog-<slug>.png (1200 x 630),
// drawn at build time by scripts/prerender.js (fix list F04).
export const blogImage = (path) => `/og-blog-${path.split('/').pop()}.png`;
